const normalizeRoleIdentity = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[\s-]+/g, '_');

const isPlatformRole = (role) => [role?.id, role?.canonicalKey, role?.name]
  .some((value) => ['super_admin', 'super_administrator'].includes(normalizeRoleIdentity(value)));

export function getOrganizationAdminAccess(can = () => false) {
  return {
    canCreateUsers: can('create_users'),
    canResetPasswords: can('manage_user_passwords'),
    canManageRoles: can('manage_system_permissions'),
    canManageFeatureVisibility: can('manage_access_rules'),
  };
}

export function canOfferPlatformRole(user) {
  return normalizeRoleIdentity(user?.role) === 'super_admin';
}

export function filterManageableRoles(roles, user) {
  const source = Array.isArray(roles) ? roles : [];
  if (canOfferPlatformRole(user)) return source;
  return source.filter((role) => !isPlatformRole(role));
}

export function isValidManagedPasswordReset(password) {
  return typeof password === 'string' && password.length >= 8;
}

export function canAccessOwnerKnowledgeBase(
  canSee = () => false,
  hasOrgFeature = () => false,
) {
  return canSee('administration.knowledgeBase') && hasOrgFeature('knowledge_base');
}

export function canAccessOwnerBillingAgent(hasOrgFeature = () => false) {
  return hasOrgFeature('billing_agent');
}

export function canAccessCamhiGrantBilling(hasOrgFeature = () => false) {
  return hasOrgFeature('camhi_grant_billing');
}
